/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles((theme) => {
    const { palette } = theme;
    return {
        zodiacButton: {
            '&.sign-container': {
                padding: '0',
                textAlign: 'center',
            },
            '&.svg-image': {
                height: '3.25rem',
                paddingLeft: '0.2rem',
                paddingRight: '0.2rem',
                display: 'block',
                '& img': {
                    margin: 'auto',
                },
            },
            '&.sign-name': {
                cursor: 'pointer',
                textAlign: 'center',
                borderRadius: '50px',
                paddingTop: '0.5rem',
                paddingBottom: '0.5rem',
                fontSize: '1.125rem',
                fontWeight: 600,
                display: 'block',
                '&:hover': {
                    backgroundColor: palette.colorPrimary,
                },
            },
            '&.selected': {
                backgroundColor: palette.colorPrimary,
            },
            '& button': {
                backgroundColor: 'transparent',
                border: 'none',
                width: '100%',
                display: 'block',
                padding: 0,
            },
        },
    };
});

export default styles;
